module.exports = __webpack_public_path__ + "static/BrandieAd-65066269268c64bbb0247a9896a6dd35.mp4";